<div class="login-body">
    @if (app.mainConfig?.authRules != null) {
    <div class="login-panel">
        <div class="login-header">
            <img class="login-logo" [src]="app.getLogoLoginPngUrl()" />
            <h1>Login</h1>
            <h2>{{app.appName}}</h2>
        </div>
        @switch (status) {
            @case ("login") {
                <div class="mt-5">
                    @if (app.mainConfig.authRules.loginUserNameHint) {
                        <p class="login-user-name-hint">{{app.mainConfig.authRules.loginUserNameHint}}</p>
                    }
                    <sm-form [form]="form"></sm-form>
                </div>
            }
            @case ("inputInformation") {
                <sm-form class="mt-5" [form]="inputInformationForm"></sm-form>
            }
        }
    </div>
    }
</div>
<p-toast key="top" position="top-center"></p-toast>
